import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div class="p-loader-container">
      <div class="p-GreenWood-loader">
        <div class="p-loader-text">WealthBuilders</div>
        <div class="p-loader-circle"></div>
      </div>
    </div>
  );
};

export default Loader;
